import { ShotFrame } from "./ShotFrame";
import { CrtScreenPreview } from "./previews";
import { Reveal } from "./motion";

export function Showcase() {
  return (
    <section className="relative mx-auto max-w-5xl px-5 py-24">
      <Reveal className="mb-10 text-center">
        <p className="lp-section-label">Live in the call</p>
        <h2 className="lp-pixel mt-4 text-[1.6rem] leading-tight text-text-primary sm:text-[2.4rem]">
          PRESS START <span className="lp-neon">TOGETHER</span>
        </h2>
      </Reveal>

      <Reveal delay={0.1}>
        <ShotFrame
          src="/landing/gameplay.png"
          label="A game running inside the call"
          fallback={<CrtScreenPreview />}
        />
      </Reveal>

      <Reveal delay={0.2} className="mt-6 text-center">
        <p
          className="lp-term mx-auto max-w-[46ch] text-[1.3rem]"
          style={{ color: "var(--crt-ink-dim)" }}
        >
          Everyone in the voice channel watches the same screen — cheer on the run,
          backseat the boss fight, take turns on the sticks.
        </p>
      </Reveal>
    </section>
  );
}
